import { uuid25 } from "../../uuid/dist/uuid25.js";
import { deepMerge } from "../deepMerge.js";
//#region src/utils/collection/tableGroup.entity.ts
var createTableGroup = (value) => deepMerge({
	id: uuid25(),
	name: "",
	color: "",
	ui: {
		x: 200,
		y: 100,
		width: 400,
		height: 300,
		zIndex: 1
	}
}, value ?? {});
//#endregion
export { createTableGroup };
